import { useRef } from 'react';
import '../machine_css.css';
import SearchIcon from '../../Icons/Search_icon.png';
import { useTranslation } from 'react-i18next';
import Keyboard from './keyboard';
// import ToggleLanguage from '../../buttons/ToggleLanguage';

function Search(props) {
  const { input, setInput, show, setShow } = props;
  const { t } = useTranslation();

  const keyboard = useRef();

  const onChangeInput = (event) => {
    const input = event.target.value;
    setInput(input);
    keyboard.current.setInput(input);
  };
  const handleClose = () => {
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
  };

  return (
    <div className="d-flex justify-content-center align-items-center mt-4 m-search">
      {/* <ToggleLanguage p="p" l={props.l}/> */}
      <input
        style={{ display: 'none' }}
        id="myinput"
        type="search"
        placeholder={`${t('Search')}...`}
        value={input}
        onClick={handleShow}
        onChange={onChangeInput}
        aria-label="Search"
        className="search-form"
      />
      <img
        src={SearchIcon}
        alt="search"
        style={{
          display: 'none',
          position: 'relative',
          right: '2.3em',
          width: '28px',
          height: '28px',
        }}
      />
      <Keyboard
        show={show}
        setShow={setShow}
        handleClose={handleClose}
        input={input}
        setInput={setInput}
        keyboard={keyboard}
      />
    </div>
  );
}
export default Search;
